import { Link } from "@tanstack/react-router";
import { useT } from "../i18n";
import { HeyLifeLogo } from "../components/Brand";

const FEATURES: Array<[key: string, color: string]> = [
  ["home", "var(--dim-pray)"],
  ["prayer", "var(--dim-share)"],
  ["grow", "var(--dim-grow)"],
  ["challenges", "var(--dim-decide)"],
  ["community", "var(--dim-fam)"],
  ["gym", "var(--dim-serve)"],
];

export function OnePager() {
  const { t } = useT();
  return (
    <div className="lp">
      <header>
        <a className="brand" href="/" aria-label="Hey Life">
          <HeyLifeLogo height={26} duotone />
        </a>
        <Link to="/admin" className="btn secondary">
          {t("landing.adminLogin")}
        </Link>
      </header>
      <section className="hero">
        <div>
          <p className="eyebrow">
            Hey Church · App
          </p>
          <h1>
            {t("landing.title")} <em>{t("landing.titleAccent")}</em>
          </h1>
          <p>{t("landing.tagline")}</p>
          <div className="stores">
            <a className="btn" href="https://apps.apple.com/app/id0000000000">
              {t("landing.appStore")}
            </a>
            <a className="btn" href="https://play.google.com/store/apps/details?id=de.heychurch.heylife">
              {t("landing.playStore")}
            </a>
          </div>
        </div>
        <div className="phone" aria-hidden="true">
          <img src="/welcome-photo.webp" alt="" />
        </div>
      </section>
      <section className="features">
        <h2>{t("landing.featuresTitle")}</h2>
        {FEATURES.map(([key, color]) => (
          <article className="feature" key={key}>
            <div className="dot" style={{ background: color }} />
            <h3>{t(`landing.features.${key}.title`)}</h3>
            <p className="muted">{t(`landing.features.${key}.body`)}</p>
          </article>
        ))}
      </section>
      <footer>
        <span>© {new Date().getFullYear()} {t("landing.madeBy")}</span>
        <span>
          <a href="https://heychurch.de/impressum">{t("landing.imprint")}</a> · <a href="https://heychurch.de/datenschutz">{t("landing.privacy")}</a>
        </span>
      </footer>
    </div>
  );
}
